import type { SubscriptionResponse } from "@bitwarden/web-vault/app/models/view/subscription/subscription.view";
import type {
  SubscriptionPaymentCycle,
  SubscriptionPaymentProvider,
  SubscriptionTier,
} from "./subscription.type";

export const AUTO_REDEEM_CREDITS = 1000;
export const AUTO_REDEEM_DAYS = 30;

export type AutoRedemptionStatus = "success" | "insufficient_credits" | "skipped" | "failed";

export type AutoRedemptionEnrollment = {
  enabled: boolean;
  account_id: string;
  amount: number;
  updated_at: string | null;
};

export type PendingAutoRedemption = {
  id: string;
  status: AutoRedemptionStatus;
  renewal_period: string;
  credits_required: number;
  credits_available?: number | null;
  subscription_id?: string;
  created_at?: string;
  skip_reason?: string;
};

export type AttemptAutoRedemptionResponse = {
  attempted: boolean;
  reason?: string;
  outcome?: PendingAutoRedemption;
};

export type AutoRedemptionCronUserResponse = AttemptAutoRedemptionResponse & {
  processed?: boolean;
};

export type AutoRedemptionCronAllResultRow = {
  user_id: string;
  dynamo_id?: string;
  processed?: boolean;
  attempted?: boolean;
  reason?: string;
  outcome_status?: string;
  error?: string;
};

export type AutoRedemptionCronAllResponse = {
  enrollment_count: number;
  results: AutoRedemptionCronAllResultRow[];
};

export type AcknowledgeAutoRedemptionResponse = {
  acknowledged: boolean;
};

/** Active subscription fields needed for auto-redeem eligibility. */
export type AutoRedeemSubscriptionRef = {
  active: boolean;
  tier: SubscriptionTier;
  payment_cycle: SubscriptionPaymentCycle;
  payment_provider: SubscriptionPaymentProvider;
  date_renewal?: string;
};

/** gloss-api getActive returns full activeSubscription plus optional pending outcome. */
export type GetActiveWithPendingResponse = SubscriptionResponse & {
  pending_auto_redemption?: PendingAutoRedemption;
};
